module.exports = __webpack_public_path__ + "static/en_internationalization-c60e38f05d7e3a49f7c0213a6975b7b4.png";